"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerModel = void 0;
const core_1 = require("@angular/core");
const api_1 = require("../../services/api");
const enums_1 = require("../../../@shared-types/customer/enums");
let CustomerModel = class CustomerModel {
    constructor(api) {
        this.api = api;
        this.getAll = (page) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.get(`/api/customers/customers/${page}`);
        });
        this.get = (customerId) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.get(`/api/customers/customer/${customerId}`);
        });
        this.getName = (customerId) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.get(`/api/customers/name/${customerId}`).then((res) => res.name);
        });
        this.put = (update, customerId) => __awaiter(this, void 0, void 0, function* () {
            return this
                .api.put(`/api/customers/customer/${customerId}`, update);
        });
        // TODO: Check, if customer with same data was not saved before
        this.post = (stub) => __awaiter(this, void 0, void 0, function* () { return this.api.post('/api/customers/customer', stub); });
        this.delete = (customerId) => __awaiter(this, void 0, void 0, function* () { return this.api.delete(`/api/customers/customer/${customerId}`); });
        this.find = (query) => __awaiter(this, void 0, void 0, function* () { return this.api.post('/api/customers/find', { query }); });
        /** Returns a valid `Customer` object with example data */
        this.getExample = () => ({
            address1: 'Musterweg 82a',
            address2: '',
            city: 'Musterhausen',
            zip: '97261',
            companyName: '',
            country: 'D',
            creationDate: new Date(),
            creationUserId: -1,
            email: 'mail@musterhausen.de',
            externalId: null,
            firstName: 'Muster',
            lastName: 'Kunde',
            id: '12345',
            modificationDate: new Date(),
            modificationUserId: -1,
            phone: '',
            salutation: enums_1.ESalutation.MALE,
            title: '',
            type: enums_1.ECustomerType.PRIVATE,
        });
        this.getFormalSalutation = (customerId, c) => __awaiter(this, void 0, void 0, function* () {
            const customer = c || (yield this.get(customerId));
            if (!customer.lastName)
                return 'Sehr geehrte Damen und Herren';
            switch (customer.salutation) {
                case enums_1.ESalutation.FEMALE: return `Liebe Frau ${customer.lastName}`;
                case enums_1.ESalutation.MALE: return `Lieber Herr ${customer.lastName}`;
                default: return 'Sehr geehrte Damen und Herren';
            }
        });
    }
};
CustomerModel = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object])
], CustomerModel);
exports.CustomerModel = CustomerModel;
